// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TPZ9K","type":"styles_type__3aeHB","choices":"styles_choices__1vY8c"};